/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_AcceptInputs */

const th_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตอบรับ`)
};

const en_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept`)
};

const ja_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参加する`)
};

const zh_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接受`)
};

const es_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptar`)
};

const pt_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceitar`)
};

const id_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terima`)
};

const fr_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepter`)
};

const tl_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggapin`)
};

const vi_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhận`)
};

const ko_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수락`)
};

const de_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusagen`)
};

const ru_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Принять`)
};

const tr_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kabul et`)
};

const it_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accetta`)
};

const pl_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przyjmij`)
};

const uk_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прийняти`)
};

const hi_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वीकार करें`)
};

const ar_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قبول`)
};

const ms_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terima`)
};

const bn_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`গ্রহণ`)
};

const zh_tw2_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接受`)
};

const zh_hk2_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接受`)
};

const ur_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قبول کریں`)
};

const fa_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پذیرفتن`)
};

const sw_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kubali`)
};

const nl_meeting_accept = /** @type {(inputs: Meeting_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aannemen`)
};

/**
* | output |
* | --- |
* | "Accept" |
*
* @param {Meeting_AcceptInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_accept = /** @type {((inputs?: Meeting_AcceptInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_AcceptInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_accept(inputs)
	if (locale === "ja") return ja_meeting_accept(inputs)
	if (locale === "zh") return zh_meeting_accept(inputs)
	if (locale === "es") return es_meeting_accept(inputs)
	if (locale === "pt") return pt_meeting_accept(inputs)
	if (locale === "id") return id_meeting_accept(inputs)
	if (locale === "fr") return fr_meeting_accept(inputs)
	if (locale === "tl") return tl_meeting_accept(inputs)
	if (locale === "vi") return vi_meeting_accept(inputs)
	if (locale === "ko") return ko_meeting_accept(inputs)
	if (locale === "de") return de_meeting_accept(inputs)
	if (locale === "ru") return ru_meeting_accept(inputs)
	if (locale === "tr") return tr_meeting_accept(inputs)
	if (locale === "it") return it_meeting_accept(inputs)
	if (locale === "pl") return pl_meeting_accept(inputs)
	if (locale === "uk") return uk_meeting_accept(inputs)
	if (locale === "hi") return hi_meeting_accept(inputs)
	if (locale === "ar") return ar_meeting_accept(inputs)
	if (locale === "ms") return ms_meeting_accept(inputs)
	if (locale === "bn") return bn_meeting_accept(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_accept(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_accept(inputs)
	if (locale === "ur") return ur_meeting_accept(inputs)
	if (locale === "fa") return fa_meeting_accept(inputs)
	if (locale === "sw") return sw_meeting_accept(inputs)
	if (locale === "nl") return nl_meeting_accept(inputs)
	return en_meeting_accept(inputs)
});